/**
 * Global 401 handler for the api client (#27).
 *
 * When an authenticated request returns 401 mid-session (cookie expired
 * between visits, sign-out from another device, etc.), bounce the user
 * to /login with a return-URL.
 *
 * Wired into the axios response error interceptor in client.ts.
 */
import { toast } from 'sonner';
import { isSigningOut } from './signOutFlag';

let _redirecting = false;

const AUTH_PATH_PATTERN =
  /^\/(login|sign-up|forgot-password|reset-password|email-verified|email-sent|accept-invitation)/;

export function handleSessionExpired() {
  if (_redirecting) return;
  if (isSigningOut()) return; // sign-out is its own happy path

  _redirecting = true;

  toast.error('Session expired — please sign in again', { id: 'session-expired' });

  const currentPath = window.location.pathname + window.location.search;
  const isAuthPath = AUTH_PATH_PATTERN.test(window.location.pathname);
  const redirect = isAuthPath ? '/' : currentPath;

  // Hard navigation to ensure the auth context resets cleanly. A
  // history-API navigate() would keep the React tree mounted with stale
  // session data.
  window.location.href = `/login?redirect=${encodeURIComponent(redirect)}`;
}
